import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import RateStar from './components/RateStar';

const StarRating: React.FC<{
  value: number | null;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: number) => void;
  editable: boolean;
}> = ({ onChange, value, editable }) => {
  const [isLandScape, setIsLandScape] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > window.innerHeight) {
        setIsLandScape(true);
      } else {
        setIsLandScape(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        '& > *:not(:last-child)': {
          marginRight: isLandScape ? '5.4vw' : '4.4vw',
        },
      }}
    >
      {Array(5)
        .fill(0)
        .map((_, index) => {
          return (
            <Box key={index} onClick={() => onChange(index + 1)}>
              {editable && (
                <RateStar
                  type={value && index + 1 <= value ? 'rate' : 'unRate'}
                  isLandScape={isLandScape}
                />
              )}
              {!editable && (
                <RateStar
                  type={value && index + 1 <= value ? 'lockRate' : 'unRate'}
                  isLandScape={isLandScape}
                />
              )}
            </Box>
          );
        })}
    </Box>
  );
};

export default StarRating;
